/* ==========================================================================
   Origen — capa del theme sobre el formulario COD de Releasit
   --------------------------------------------------------------------------
   Vive APARTE de sections/origen-cafe-hero.liquid a propósito: ese archivo lo
   editan varias sesiones a la vez y estas tres piezas se perdieron dos veces
   al sobrescribirlo. Aquí no depende de nada interno del hero — la cantidad
   del pack se lee del DOM (el input de cantidad del formulario del producto).

   MODELO UNIFICADO (2026-08-27, decisión de Jesús): el popup es el único
   dueño del pedido. El cliente elige su bundle DENTRO del formulario (las
   ofertas de la app, visibles); las tarjetas de la página son vitrina y no
   cambian ningún estado. Eso eliminó el forzado de ofertas y su vigilante,
   que eran la fuente de las carreras de precios.

   Hace tres cosas:
   1. Fija la variante base (bolsa suelta) aunque la URL traiga otra.
   2. Traduce los textos que el panel de Releasit guarda fijos en inglés.
   3. Neutraliza los clics en las tarjetas de pack (solo feedback visual).

   El único cierre del formulario es el contra entrega (2026-08-30, decisión
   de Jesús): se retiró el botón de "Pago por WhatsApp" que vivía aquí, con
   todo lo que solo lo alimentaba (el mensaje del chat y la lectura de los
   campos). El pago se hace en el sitio, no en el chat.
   ========================================================================== */
(function () {
  'use strict';

  var ES = {
    'CASH ON DELIVERY': 'PAGA AL RECIBIR',
    'Shipping method': 'Método de envío',
    'Discounts': 'Descuento',
    'Free': 'Gratis'
  };

  function wrap() { return document.getElementById('rsi_form_wrapper'); }

  /* --- 0. La bolsa base manda -------------------------------------------
     Los packs multiplican la variante de 1 bolsa. Pero la página se renderiza
     con la variante que venga en la URL, así que un enlace con ?variant= (los
     que genera el propio admin de Shopify, o un anuncio viejo) hacía que los
     packs apuntaran a "2 Bolsas" o "3 Bolsas": el pedido salía con la variante
     equivocada y la bodega despachaba mal. Aquí se fuerza siempre la primera
     variante, que es la bolsa suelta.
     ---------------------------------------------------------------------- */
  function fijarVarianteBase() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var prod = meta && meta.product;
    if (!prod || !prod.variants || !prod.variants.length) return;
    var base = String(prod.variants[0].id);

    var packs = document.querySelectorAll('.oc-pack[data-oc-qty]');
    if (!packs.length) return; // sin modo cantidad no hay nada que forzar
    var enModoCantidad = false;
    [].forEach.call(packs, function (p) {
      if (parseInt(p.getAttribute('data-oc-qty'), 10) > 0) enModoCantidad = true;
    });
    if (!enModoCantidad) return;

    [].forEach.call(packs, function (p) {
      if (p.getAttribute('data-oc-vid') !== base) p.setAttribute('data-oc-vid', base);
    });
    var input = document.querySelector('[data-oc-varinput]');
    if (input && input.value !== base) {
      input.value = base;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* --- 1. Textos en español ---------------------------------------------- */

  function esSwap() {
    var w = wrap();
    if (!w) return;
    var walker = document.createTreeWalker(w, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var key = node.nodeValue.trim();
      if (ES[key]) node.nodeValue = node.nodeValue.replace(key, ES[key]);
    }
  }

  /* --- 2. Las tarjetas de pack son vitrina --------------------------------
     Antes cada tarjeta cambiaba cantidad y disparaba una re-sincronización
     de la app (popstate + refetch): de ahí salían las carreras de precios.
     Ahora el clic se intercepta en fase captura ANTES de que lo vea el
     manejador del hero: la tarjeta solo se marca visualmente y nada más
     cambia. El bundle real se elige dentro del formulario. */

  function soloVitrina(e) {
    var pack = e.target.closest && e.target.closest('.oc-pack');
    if (!pack) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.stopImmediatePropagation();
    e.preventDefault();
    var grupo = (pack.parentElement || document).querySelectorAll('.oc-pack');
    [].forEach.call(grupo, function (p) {
      p.setAttribute('aria-checked', p === pack ? 'true' : 'false');
    });
    pintaTarjeta(pack);
  }
  document.addEventListener('click', soloVitrina, true);
  document.addEventListener('keydown', soloVitrina, true);

  /* --- 2b. El pack resaltado gobierna el botón de pago con tarjeta --------
     Único estado que las tarjetas SÍ controlan (2026-08-31, escalera dual
     como en Aurelys): el enlace de pago anticipado es un permalink al
     checkout de Shopify con la cantidad y el código de descuento del pack
     (atributos data-tarjeta-* que pinta el hero). Camino aparte del COD:
     jamás toca el formulario de la app ni su popup. */
  function pintaTarjeta(pack) {
    var caja = document.querySelector('[data-oc-tarjeta-caja]');
    if (!caja) return;
    var btn = caja.querySelector('[data-oc-tarjeta]');
    var texto = pack.getAttribute('data-tarjeta-texto');
    if (!btn || !texto) { caja.setAttribute('hidden', ''); return; }
    caja.removeAttribute('hidden');
    var span = btn.querySelector('[data-oc-tarjeta-txt]');
    if (span) span.textContent = texto;
    var url = btn.getAttribute('data-oc-tarjeta-base') + ':' + (pack.getAttribute('data-oc-qty') || '1');
    var dcto = pack.getAttribute('data-tarjeta-dcto');
    if (dcto) url += '?discount=' + encodeURIComponent(dcto);
    btn.setAttribute('href', url);
  }

  /* --- 5. Arranque ligero -------------------------------------------------
     Medido con HAR: los 4 videos del cierre (autoplay + loop, a ~6000px del
     viewport) descargaban y reproducían desde el segundo cero — el autoplay
     anula el preload="metadata" — y le robaban el ancho de banda a la app
     COD, que es lo único que el cliente espera para poder comprar. Aquí se
     les corta la descarga y se restauran solos cuando el cliente se acerca. */
  function aligerarVideos() {
    var videos = document.querySelectorAll('video[autoplay]');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (!en.isIntersecting) return;
        var v = en.target;
        io.unobserve(v);
        (v.__ocSrcs || []).forEach(function (s) { v.appendChild(s); });
        v.load();
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }, { rootMargin: '900px 0px' });

    [].forEach.call(videos, function (v) {
      var r = v.getBoundingClientRect();
      if (r.top < innerHeight * 2) return; // cerca del fold: dejarlo en paz
      v.pause();
      v.removeAttribute('autoplay');
      v.__ocSrcs = [].slice.call(v.querySelectorAll('source'));
      v.__ocSrcs.forEach(function (s) { v.removeChild(s); });
      v.removeAttribute('src');
      v.load(); // aborta la conexión de streaming ya abierta
      io.observe(v);
    });
  }

  // el carrusel usa imágenes lazy de 1200px: al pasar de slide había que
  // esperar la descarga. Tras el load, con la red ya libre, se precalientan.
  function precalentarCarrusel() {
    var imgs = document.querySelectorAll('[data-oc-viewport] img[loading="lazy"]');
    [].forEach.call(imgs, function (img) {
      if (img.currentSrc || img.src) { var pre = new Image(); pre.src = img.currentSrc || img.src; }
    });
  }
  window.addEventListener('load', function () {
    if ('requestIdleCallback' in window) requestIdleCallback(precalentarCarrusel, { timeout: 4000 });
    else setTimeout(precalentarCarrusel, 1500);
  });

  aligerarVideos();
  document.addEventListener('DOMContentLoaded', aligerarVideos);

  /* --- 6. El toque cuenta desde el primer segundo -------------------------
     La app tarda ~2 s (más en móvil) en habilitar su botón: 391 KB de JS que
     hay que bajar y ejecutar. En vez de hacer esperar al cliente, un toque
     sobre el botón deshabilitado guarda la intención y abre el formulario
     solo en cuanto la app esté lista. Los botones disabled se tragan el
     click, así que se escucha pointerdown en el documento y se comprueba a
     mano si el punto cayó sobre el botón. */
  (function () {
    var esperando = false;
    document.addEventListener('pointerdown', function (e) {
      if (esperando) return;
      var btn = document.getElementById('rsi_buy_now_button');
      if (!btn || !btn.disabled) return;
      var r = btn.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
      esperando = true;
      btn.setAttribute('data-oc-esperando', '1');
      var t0 = Date.now();
      (function abrir() {
        var b = document.getElementById('rsi_buy_now_button');
        if (b && !b.disabled) {
          b.removeAttribute('data-oc-esperando');
          esperando = false;
          b.click();
          return;
        }
        if (Date.now() - t0 < 15000) setTimeout(abrir, 120);
        else { esperando = false; if (b) b.removeAttribute('data-oc-esperando'); }
      })();
    }, true);
  })();

  // antes de que el cliente pueda tocar nada, y otra vez si el theme repinta
  fijarVarianteBase();
  document.addEventListener('DOMContentLoaded', fijarVarianteBase);

  var pendiente = false;
  new MutationObserver(function () {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      esSwap();
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
